import { render, staticRenderFns } from "./consultant.vue?vue&type=template&id=565f7a4a&scoped=true"
import script from "./consultant.vue?vue&type=script&lang=js"
export * from "./consultant.vue?vue&type=script&lang=js"
import style0 from "./consultant.vue?vue&type=style&index=0&id=565f7a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f7a4a",
  null
  
)

export default component.exports